import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiUsuarioService } from '../services/api-usuario.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {

    constructor(private apiUsuario: ApiUsuarioService, private router: Router){}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.verificarAcesso(state.url);
    }

    private verificarAcesso(redirectUrl: string) {
        if (this.apiUsuario.getCredenciais()) {
            return true;
        }

        this.router.navigate(['/login'], { queryParams: { returnUrl: redirectUrl } });
        return false;
    }
}
